export const currencyApi = 'https://api.monobank.ua/bank/currency';
